import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import NotFound from "./pages/NotFound";
import Pages from "./pages/Pages";
import Navigation from "./pages/Navigation";
import ContactForms from "./pages/ContactForms";
import Blogs from "./pages/Blogs";
import LocationBlogs from "./pages/LocationBlogs";
import MediaLibrary from "./pages/MediaLibrary";
import Drafts from "./pages/Drafts";
import Settings from "./pages/Settings";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ToastContainer } from 'react-toastify';
import AddPages from "./pages/AddPages";
import AddBlogs from "./pages/AddBlogs";
import AddLocationBlog from "./pages/AddLocationBlog";
import AddCaseStudy from "./pages/AddCaseStudy";
import CaseStudy from "./pages/CaseStudy";
import JobListing from "./pages/JobListing";
import AddJob from "./pages/AddJob";
import NewsLetters from "./pages/NewsLetters";
import Contacts from "./pages/Contacts";
import Section from "./pages/section";
import AddSection from "./pages/addsection";
import AddTemplate from "./pages/addtemplate";
import CreateNewForm from "./pages/createnewform";
import ViewTemplate from "./pages/viewtemplate";
import EditForm from "./pages/Editform";
import ViewSection from "./pages/viewsection";
import FormList from "./pages/formlist";
import EditPages from "./pages/EditPage";
import Organization from "./pages/Organization/Organization";
import Projects from "./pages/Projects/Projects";
import AddOrganization from "./pages/Organization/addorganization";
import AddProjects from "./pages/Projects/addProjects";
import NewsList from "./pages/News/NewsList";
import AddNews from "./pages/News/AddNews";
import Account from "./pages/Account";
import CreateNewAccount from "./pages/CreateNewAccount";
import EditAccount from "./pages/EditAccount";
import Role from "./pages/Role";
import CreateNewRole from "./pages/CreateNewRole";
import EditRole from "./pages/EditRole";
import CreateLocalizedBlog from "./pages/Blog/addChildBlog";
import AddLocalizedLocationBlog from "./pages/LocationBlog/AddLocalizedLocationBlog";

function PrivateRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* Private Routes */}
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route path="organization" element={<Organization />} />
            <Route path="/organization/add-organization" element={<AddOrganization />} />
            <Route path="projects" element={<Projects />} />
            <Route path="projects/add" element={<AddProjects />} />
            <Route path="pages" element={<Pages />} />
            <Route path="pages/add-new" element={<AddPages />} />
            <Route path="pages/:pageId" element={<AddPages />} />
            <Route path="pages/:pageId/:locale" element={<AddPages />} />
            <Route path="navigation" element={<Navigation />} />
            <Route path="all-forms" element={<ContactForms />} />
            <Route path="/all-forms/edit/:id" element={<EditForm />} />
            <Route path="all-forms/create-from" element={<CreateNewForm />} />
            <Route path="/all-forms/:type" element={<FormList />} />
            <Route path="contact-forms" element={<Contacts />} />
            <Route path="news-letters" element={<NewsLetters />} />
            <Route path="blogs" element={<Blogs />} />
            <Route path="location-blogs" element={<LocationBlogs />} />
            <Route path="/section" element={<Section />} />
            <Route path="/section/section-detail/:id" element={<ViewSection />} />
            <Route path="/section/template/:id" element={<ViewTemplate />} />
            <Route path="section/add-section" element={<AddSection />} />
            <Route path="section/add-template" element={<AddTemplate />} />
            <Route path="blogs/add-blogs" element={<AddBlogs />} />
            <Route path="blogs/:blogId" element={<AddBlogs />} />
            <Route path="location-blogs/add" element={<AddLocationBlog />} />
            <Route path="location-blogs/:storyMapId" element={<AddLocationBlog />} />
            <Route path="case-studies" element={<CaseStudy />} />
            <Route path="case-studies/add-case-study" element={<AddCaseStudy />} />
            <Route path="case-studies/:blogId" element={<AddCaseStudy />} />
            {/* <Route path="job-listing" element={<JobListing />} />
            <Route path="job-listing/add-job" element={<AddJob />} />
            <Route path="job-listing/:jobId" element={<AddJob />} /> */}
            <Route path="media-library" element={<MediaLibrary />} />
            <Route path="media-library/drafts" element={<Drafts />} />
            <Route path="settings" element={<Settings />} />
            <Route path="news-list" element={<NewsList />} />
            <Route path="news/add-news" element={<AddNews />} />
            <Route path="news/:newsId" element={<AddNews />} />
            <Route path="account" element={<Account />} />
            <Route path="role" element={<Role />} />
            <Route path="account/create-new-account" element={<CreateNewAccount />} />
            <Route path="account/edit-account/:id" element={<EditAccount />} />
            <Route path="role/create-new-role" element={<CreateNewRole />} />
            <Route path="role/edit-role/:id" element={<EditRole />} />
            <Route path="blogs/new/:id" element={<CreateLocalizedBlog />} />
            <Route path="location-blogs/new/:id" element={<AddLocalizedLocationBlog />} />


          </Route>

          {/* 404 Fallback */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </AuthProvider>
    </Router>
  );
}

export default App;
